import * as yup from "yup"
import { isValidPhoneNumber } from "react-phone-number-input";
// Define Yup schema for a single passenger
const passengerSchema = yup.object().shape({
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    phone: yup
        .string()
        .required("Phone is required")
        .test("is-valid-phone", "Invalid phone number", (value) =>
            isValidPhoneNumber(value || "")
        ),

    dob: yup
        .date()
        .nullable()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .max(new Date(), "Date of birth cannot be in the future")
        .required("Date of birth is required"),
    passportExpiration: yup
        .date()
        .nullable()
        .transform((value, originalValue) => (originalValue === "" ? null : value))
        .min(new Date(), "Passport is expired")
        .required("Passport expiration is required"),
    gender: yup.string().required("Gender is required"),
    nationality: yup.string().required("Nationality is required"),
    passportCountry: yup.string().required("Passport country is required"),
    passportNumber: yup.string().required("Passport number is required"),
    meal: yup.string().optional(),
})

// Define Yup schema for the entire booking form
const BookingFormSchema = yup.object().shape({
    passengers: yup.array().of(passengerSchema),
})

export { BookingFormSchema }